export default __webpack_public_path__ + "static/media/goes-without-saying.b50006c0.mp3";